export const messages = {
  en: {
    syncPartnerGoodsPrice: {
      confirmTitle: 'Please confirm your operation!',
      confirmContent: 'Confirm to sync partner goods price',
      cancel: 'Cancel',
      confirm: 'Confirm Sync',
      syncSuccess: 'Sync successfully'
    }
  },
  zh: {
    syncPartnerGoodsPrice: {
      confirmTitle: '请确认您的操作!',
      confirmContent: '确定同步合作商品价格',
      cancel: '点错了',
      confirm: '确认同步',
      syncSuccess: '同步成功'
    }
  }
}